import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';
import { GameGroup, Bet } from '../../entities/gamegroup';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-bet',
  templateUrl: 'bet.html'
})

export class  BetPage extends MainPage {
    public gameGroups: GameGroup[];
    public selectedGroup: GameGroup;
    private lastGroupName: string;
    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public contestService: ContestService, 
        protected alertController: AlertController,
        protected userService: UserService,
        protected appCtrl: App) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.lastGroupName = "";
        this.loadPage();
    }

    public loadPage(): void {
        this.contestService.GetGamesToBet().then((data: GameGroup[]) => {
            this.gamesLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public doBet(): void {
        this.lastGroupName = this.selectedGroup.Fullname;
        this.contestService.DoBet(this.gameGroups).then((data: GameGroup[]) => {
            this.betsPosted(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public betsPosted(gameGroup: GameGroup[]): void {
        this.presentToast("Aposta realizada com sucesso");
        this.gamesLoaded(gameGroup);
    }

    public gamesLoaded(gameGroup: GameGroup[]): void {
        this.gameGroups = gameGroup;
        for(var i=0; i<this.gameGroups.length; i++) {
            if (this.lastGroupName === this.gameGroups[i].Fullname) {
                this.selectedGroup = this.gameGroups[i];
                break;
            }
            else if (this.gameGroups[i].IsDefault) {
                this.selectedGroup = this.gameGroups[i];
                if (this.lastGroupName === "") {
                    break;
                }
            }
        }
    }

    public setGoal(game: Bet, team: number, event: any): void {
        game.IsChanged = true;
        if (team == 1) {
            game.GoalsTeam1 = parseInt(event.srcElement.value);
        }
        else {
            game.GoalsTeam2 = parseInt(event.srcElement.value);
        }
    }

    public setChanged(game: Bet): void {
        game.IsChanged = true;
    }

    /*public setGroup(): void {
        for(var i=0; i<this.selectedGroup.Bets.length; i++) {
            this.selectedGroup.Bets[i].IsChanged = true;
        }
    }*/

    public compareGroup(g1: GameGroup, g2:GameGroup): boolean {
        return g1.Fullname === g2.Fullname;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contest/bet.ts